<template>
	<UserRegistrationLayout>
		<div class="display-flex flex-column">
			<div class="slot-title mb-2">Enter confirmation code</div>
			<p>
				We emailed you a verification code to {{ email }}. <br />
				Enter the code below to confirm your email.
			</p>
			<div class="otp-input-container display-flex flex-row mt-6">
				<v-otp-input :error="isCodeWrong" @finish="(code) => $emit('code-submitted', code)" type="number" length="4"></v-otp-input>
			</div>
		</div>
	</UserRegistrationLayout>
</template>

<script>
import UserRegistrationLayout from '@/views/userRegistration/UserRegistrationLayout';

export default {
	name: 'PortalAuthEnterCode',
	props: {
		email: { type: String, required: true },
		isCodeWrong: { type: Boolean, default: false },
	},
	components: {
		UserRegistrationLayout,
	},
	data: () => ({
		verificationCode: '',
	}),
};
</script>

<style scoped lang="scss">
.otp-input-container {
	::v-deep {
		.v-text-field__slot {
			height: 91px;
			padding: 0px;
			max-width: 70px;
			box-shadow: 0px 3px 10px #00000029;
		}
		.v-input__slot {
			min-height: 91px !important;
		}
	}
}
</style>
